module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Light-WebS.542dfda0.eot";